export default __webpack_public_path__ + "static/media/icon-warning-white.1886f054.svg";